import { render, staticRenderFns } from "./testingPagination.vue?vue&type=template&id=ed03a3fa&"
import script from "./testingPagination.vue?vue&type=script&lang=js&"
export * from "./testingPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports